<template>
  <div>
    <v-container fluid grid-list-md>

      <v-toolbar class="mb-4 no-right-padding">
        <v-toolbar-title>
          Workline
        </v-toolbar-title>
        <v-spacer></v-spacer>
          <v-flex xs12 sm4>
            <v-autocomplete
              v-model="filterUserId"
              hide-details
              dense
              outline
              :items="users"
              item-text="name"
              item-value="id"
              label="Employee"
            />
          </v-flex>
      </v-toolbar>

      <v-progress-linear v-if="loading" :indeterminate="true" color='success'></v-progress-linear>


      <v-layout row wrap>
        <v-flex xs12 sm6>
          <draggable
            :disabled="loading"
            class="workline-group elevation-3"
            :list="worklines"
            group="people"
            @change="moveTask($event, worklines)"
          >
            <v-card
              class="workline-group-item"
              v-for="(workline, index) in worklines"
              :key="index"

            >
              <v-card-text class="pa-1">
                <v-layout>
                  <v-flex xs12>
                    <div class="tasks_page__list--item_chip">{{ workline.task.short_name.toUpperCase() }}</div>
                    <span>{{ workline.task.title }}</span>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      :to="{ name: 'tasks-form', params: {project_id: workline.task.project_id, task_id: workline.task.id }}"
                      target="_blank"
                      class="ml-auto"
                      color="info"
                      icon
                      small
                    >
                      <v-icon size="18">open_in_new</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="py-1">
                <v-btn depressed small :color="workline.status == 'open' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'open')">
                  Open
                </v-btn>
                <v-btn depressed small :color="workline.status == 'postpone' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'postpone')">
                  Postponed
                </v-btn>
                <v-btn depressed small :color="workline.status == 'done' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'done')">
                  Finished
                </v-btn>
                <v-btn icon @click.stop.prevent="deleteWorkline(workline)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="workline.task.instance_users && workline.task.instance_users.length"
                  v-for="user in workline.task.instance_users"
                  :title="user.name"
                  icon
                  small
                  color="secondary"
                >
                  {{ user.short_name }}
                </v-btn>
              </v-card-actions>
              <template
                v-if="workline.task.labels && workline.task.labels.length"
              >
                <v-divider></v-divider>
                <v-card-actions class="pa-1">
                  <div class="tasks_page__list--item_labels">
                    <div
                      v-for="label in workline.task.labels"
                      class="tasks_page__list--item_chip"
                      :style="{ color: label.text_color, 'background-color': label.color}"
                    >
                      {{ label.name }}
                    </div>
                  </div>
                </v-card-actions>
              </template>
            </v-card>
          </draggable>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-text>
              <h2>Projects</h2>
              <v-divider color="secondary" dark class="my-1"></v-divider>
              <v-text-field
                class="px-2"
                v-model="search.project"
                outline
                clearable
                label="Search by title"
                hide-details
              />
              <v-list class="workline_list">
                <template v-for="(item, index) in listProjects">
                  <v-list-tile
                    :key="index"
                    @click="loadTasks(item)"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>

              <h2>Tasks</h2>
              <v-divider color="secondary" dark class="my-1"></v-divider>
              <v-text-field
                class="px-2"
                v-model="search.task"
                outline
                clearable
                label="Search by title"
                hide-details
              />
              <v-list class="workline_list tasks_page__list">
                <template v-for="(task, index) in listTasks">
                  <v-list-tile
                    class="tasks_page__list--item"
                    @click="addToWorkline(task)"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <div>
                          <div class="tasks_page__list--item_chip">{{ task.short_name.toUpperCase() }}</div>
                          <strong>{{ task.title }}</strong>
                          <div class="tasks_page__list--item_labels" v-if="task.labels && task.labels.length">
                            <div
                              v-for="label in task.labels"
                              class="tasks_page__list--item_chip"
                              :style="{ color: label.text_color, 'background-color': label.color}"
                            >
                              {{ label.name }}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="task.instance_users && task.instance_users.length">
                            <v-btn color="primary" icon v-for="user in task.instance_users" small>
                              {{ user.short_name }}
                            </v-btn>
                          </div>

                        </div>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-btn
                      class="my-0"
                      color="info"
                      icon
                      :to="{ name: 'tasks-form', params: {project_id: task.project_id, task_id: task.id }}"
                      target="_blank"
                    >
                      <v-icon>open_in_new</v-icon>
                    </v-btn>
                  </v-list-tile>

                  <v-divider v-if="index != listTasks.length - 1"/>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'Workline',
    mixins: [mixins.draggable, mixins.preloader, mixins.user],
    data() {
      return {
        loading: false,
        worklines: [],
        users: [],
        projects: [],
        tasks: [],
        filterUserId: '',
        search: {
          project: "",
          task: "",
        }
      }
    },
    computed: {
      listProjects() {
        const search = this.search.project
        return this.projects.filter(item => !search || item.name.match(new RegExp(search, "i")))
      },
      listTasks() {
        const search = this.search.task
        return this.tasks.filter(item => !search || item.title.match(new RegExp(search, "i")))
      }
    },
    methods: {
      loadProjects() {
        return this.$api.projects.list({ unlimit: 1 }).then(({ data }) => {
          this.projects = data
        })
      },
      loadUsers() {
        return this.$api.users.list({ unlimit: 1 }).then(response => {
          this.users = response.data.data ? response.data.data : response.data
        })
      },
      loadTasks(project) {
        let params = {
          unlimit: 1,
          projects: [project.id],
        }

        const query = this.$api.tasks.list(params).then(({ data }) => {
          this.tasks = data
        });

        return this.background(query)
      },
      loadWorkline() {
        this.loading = true
        return this.$api.worklines.list({ unlimit: 1, user_id: this.filterUserId }).then(response => {
          this.loading = false
          this.worklines = response.data.data ? response.data.data : response.data
        })
      },
      addToWorkline(task) {
        const data = {
          user_id: this.filterUserId,
          task_id: task.id,
        }
        this.loading = true
        this.$api.worklines.save(data).then(() => {
          this.loadWorkline()
        })
      },
      changeStatus(workline, status) {
        this.loading = true
        this.$api.worklines.changeStatus(workline.id, status).then(() => {
          this.loadWorkline()
        })
      },
      deleteWorkline(workline) {
        this.loading = true
        this.$api.worklines.delete(workline.id).then(() => {
          this.loadWorkline()
        })
      },
      moveTask(event, list) {
        if (event.moved) {
          const { element, newIndex, oldIndex } = event.moved
          const next = list[newIndex + 1]

          const data = {
            ...element,
            next: next ? next.id : 0,
          }
          this.loading = true
          this.$api.worklines.save(data).then(() => {
            this.loadWorkline()
          })
        }
      }
    },
    watch: {
      'filterUserId' () {
        this.loadWorkline()
      },
    },
    mounted() {
      this.filterUserId = this.user.id

      let preload = [this.loadProjects(), this.loadUsers()]
      preload.forEach(item => this.background(item))
      Promise.all(preload).then(() => {
        this.loadTasks(this.projects[0])
      })
    },
    components: {},
  }
</script>
